import { mapValues } from 'lodash';
import { RouteMissingError } from 'libs/error/RouteMissingError';
import { RoutePath } from './RoutePath';
/**
 * @class RouteManager
 * @since 1.0.0
 * @hidden
 */
export class RouteManager {
    //--------------------------------------------------------------------------
    // Methods
    //--------------------------------------------------------------------------
    /**
     * @constructor
     * @since 1.0.0
     */
    constructor(routes) {
        this.paths = mapValues(routes, (route) => new RoutePath(route));
    }
    /**
     * @method retrieve
     * @since 1.0.0
     */
    retrieve(name, opts) {
        return this.get(name).retrieve(opts);
    }
    /**
     * @method generate
     * @since 1.0.0
     */
    generate(name, keys, opts) {
        return this.get(name).generate(keys, opts);
    }
    //--------------------------------------------------------------------------
    // Private API
    //--------------------------------------------------------------------------
    /**
     * @method get
     * @since 1.0.0
     * @hidden
     */
    get(name) {
        const path = this.paths[name];
        if (path == null) {
            throw new RouteMissingError(name);
        }
        return path;
    }
}
